import React from 'react';
import { createLink, extractDatacenterId, getLanColor } from 'utils';
import Section from 'screens/shared/section';
import { ACTIONS_TYPES } from 'redux/local';
import { ROUTE } from 'constant';
import CreateForm from './create';

export default ({ lans = [], history = {} }) => (
  <Section
    sectionTitle="LANs"
    className="-m-t-24"
    createForm={<CreateForm />}
    createActionType={ACTIONS_TYPES.LAN.CREATE}
    isDeletePassword
    items={lans}
    itemIcon="ethernet"
    setItemIconText={(e) => (e?.properties?.public ? 'Public' : 'Private')}
    setItemIconColor={(e) => getLanColor(e?.id)}
    setItemTitle={(e) => `LAN ${e?.id} - ${e?.properties?.name}`}
    setItemDetails={(e) => `${e?.entities?.nics?.items?.length || 0} NICs`}
    itemOnClick={({ id, href }) => {
      const dcId = extractDatacenterId(href);
      history.push(createLink(ROUTE.DASHBOARD.LAN, { dcId, id }));
    }}
  />
);
